import React from 'react';
import PropTypes from 'prop-types';

const DischargePolicyPage = () => {

  // Policy content
  const dischargeText = [
    "All residents, upon discharge (unless leaving AMA or abandoning the property), will receive a discharge summary that includes a summary of the resident's involvement in services and the reason(s) for discharge, as well as the provision of other services needed by the resident following discharge, including any recommendations.",
    "In all instances, Legacy will attempt to contact your emergency contact to inform them you have been or will be discharged from our housing program, whether voluntarily or not.",
    "All clients are provided a list of resources prior to discharge. This includes local treatment facilities (DCF-licensed), FARR-certified recovery residences, meeting schedules, and community resources to ensure the highest possibility of success whether the client refuses a higher level of care or transitions.",
    "Upon discharge, you must bring all belongings with you. Legacy staff will help you gather your belongings before completing the discharge. If you leave any property in the recovery residence or abandon the property, we will hold any personal property or medication for a maximum of 30 days, after which we will dispose of these items. Legacy will make every attempt to reach the client and/or their emergency contact/family member to return their belongings. If contact is made, Legacy will secure items until arrangements are made, up to and no longer than 30 days. Medication will be destroyed, and belongings will be donated to the community closet.",
    "Upon successful program completion and discharge, residents are introduced to the Alumni Director and encouraged to participate in meetings and activities upon transition from Legacy Healing."
  ];

  return (
    <div style={{ fontFamily: "Elef Layla MF", padding: "20px", maxWidth: "800px", margin: "0 auto", lineHeight: "1.2",fontSize: "14pt" }}>
      {/* Header */}
      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            display: "inline-block",
            fontSize: "20pt",
            fontFamily: "Elef Layla MF",
            marginBottom: "15px",
            borderBottom: "2px solid black",
            paddingBottom: "0px",
          }}
        >
          Discharge Policy and Procedure
        </h2>
      </div>

      {/* Policy Content */}
      <div style={{ marginBottom: '20px' }}>
        {dischargeText.map((paragraph, index) => (
          <p key={index} style={{ marginBottom: '15px' }}>
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
};

DischargePolicyPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired
};

export default DischargePolicyPage;